import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../core";
import { customerPreserve } from "../../_shared/preserve";
import { purchaseOrderSchema } from "./schema";

export const purchaseOrderConfig = defineForm({
  id: "purchase_order",
  createEndpoint: MANUAL_DOC_ENDPOINTS.PURCHASE_ORDER,
  permission: "ManualDocumentsPO_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "PurchaseOrder",
  accountClass: "AccountPayable",
  titleKey: "purchase_order",
  schema: purchaseOrderSchema,
  preserveOnReset: customerPreserve,
  defaultFormValuesKey: "AP_PO_Form",
  hiddenSections: ["recurring"],
  sections: {
    vendor: {
      hiddenFields: [
        "vendorCountry",
        "vendorCompanyStreet",
        "vendorCompanyStreetNumber",
        "vendorCompanyLocality",
        "vendorCompanyZipCode",
        "vendorCompanyRegion",
        "logoURL",
      ],
    },
    customer: {
      hiddenFields: [
        "customerCountry",
        "currency",
        "customerCompanyStreet",
        "customerCompanyStreetNumber",
        "customerCompanyLocality",
        "customerCompanyZipCode",
        "customerCompanyRegion",
      ],
    },
  },
});
